export const REPORT_LOAN_LIST_REQUEST = 'REPORT_LOAN_LIST_REQUEST';
export const REPORT_LOAN_LIST_REQUEST_SUCCESS = 'REPORT_LOAN_LIST_REQUEST_SUCCESS';
export const REPORT_LOAN_LIST_REQUEST_ERROR = 'REPORT_LOAN_LIST_REQUEST_ERROR';

export const REPORT_LOAN_LIST_EXPORT = 'REPORT_LOAN_LIST_EXPORT';
export const REPORT_LOAN_LIST_EXPORT_SUCCESS = 'REPORT_LOAN_LIST_EXPORT_SUCCESS';
export const REPORT_LOAN_LIST_EXPORT_ERROR = 'REPORT_LOAN_LIST_EXPORT_ERROR';

export const REPORT_END_DAY_REQUEST = 'REPORT_END_DAY_REQUEST';

export const REPORT_END_DAY_EXPORT = 'REPORT_END_DAY_EXPORT';

export const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST';
export const DASHBOARD_REQUEST_SUCCESS = 'DASHBOARD_REQUEST_SUCCESS';
export const DASHBOARD_REQUEST_ERROR = 'DASHBOARD_REQUEST_ERROR';

export const END_DAY_CHANGE_STATUS = 'END_DAY_CHANGE_STATUS';
export const END_DAY_CHANGE_STATUS_SUCCESS = 'END_DAY_CHANGE_STATUS_SUCCESS';
export const END_DAY_CHANGE_STATUS_ERROR = 'END_DAY_CHANGE_STATUS_ERROR';

export const END_DAY_RE_CHANGE_STATUS = 'END_DAY_RE_CHANGE_STATUS';
export const END_DAY_RE_CHANGE_STATUS_SUCCESS = 'END_DAY_RE_CHANGE_STATUS_SUCCESS';
export const END_DAY_RE_CHANGE_STATUS_ERROR = 'END_DAY_RE_CHANGE_STATUS_ERROR';
